<template>
	<div>
		<my-navBar></my-navBar>
		<my-buyTicStatus :curStatus='2'></my-buyTicStatus>
		<div class="box">
			<div class="table">
				<ul class="title">
					<li>电影</li>
					<li>场次</li>
					<li>票数/座位</li>
					<li>金额小计</li>
				</ul>
				<ul class="val">
					<li>
						<div class="center">
							<img :src="$route.query.mvInfo.cover" class="cover">
							<div class="mvName">{{$route.query.mvInfo.name}}</div>
						</div>
					</li>
					<li>
						<div class="center">
							<div class="cineName">{{$store.state.selCineInfo.name}}</div>
							<div class="cineRoom">{{$store.state.selCineInfo.hall_name}}</div>
							<div class="time">{{$route.query.timeInfo.date}}</div>
							<div class="time">{{$route.query.timeInfo.startHM}} - {{$route.query.timeInfo.endHM}}</div>
						</div>
					</li>
					<li>
						<div class="center">
							<div class="selSeatLeg">{{$route.query.selSeatList.length}}张</div>
							<div v-for='item in $route.query.selSeatList' class="selSeatItem" :key='item.id'>
								{{item.name}}
							</div>
						</div>
					</li>
					<li>
						<div class="center itemPrice">
							<div class="itemPrice">
								¥{{$route.query.totalPrice}}
							</div>
						</div>
					</li>
				</ul>
			</div>
			<!-- <div class="infoItem pointer" @click="navToIdList">
				<div class="title">观影人信息（必填）</div>
				<div class="val">
					<div class="text">{{$store.state.idCards.length>0?'已填':'请填写'}}</div>
					<img src="@/assets/img/cIcon.png" class="cIcon">
				</div>
			</div> -->
			<div class="allPrice">
				<span class="title">实付款：</span>
				<span class="val">¥{{$route.query.totalPrice}}</span>
			</div>
			<div class="confBtn" @click="confOrder">确认订单</div>
			<div style="clear: both;"></div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'ticConfirm',
		data() {
			return {
				selCouponId: '',
				mvInfo: {
					mvName: '',
					cover: ''
				},
				timeInfo: {
					cineRoom: '',
					time: ''
				},
				ticInfo: {
					oriPrice: '',
					memPrice: '',
					selSeatList: [{
						id: '',
						name: ''
					}],
					resSeatId: []
				},
				allOriPrice: '',
				allMemPrice: '',
			}
		},
		created: function() {
			this.$route.query.mvInfo = JSON.parse(this.$route.query.mvInfo);
			this.$route.query.timeInfo = JSON.parse(this.$route.query.timeInfo);
			this.$route.query.selSeatList = JSON.parse(this.$route.query.selSeatList);
		},
		methods: {
			getIds: function() {
				var idCards = this.$store.state.idCards;
				var str = '';
				for (var i = 0; i < idCards.length; i++) {
					str += idCards[i].id + ','
				}
				str = str.substring(0, str.length - 1)
				return str;
			},
			setOrderRes: function() {
				var query = this.$route.query;
				//seats请求参数
				var selSeatList = query.selSeatList;
				var reqSeats = [];
				for (var i = 0; i < selSeatList.length; i++) {
          reqSeats.push(selSeatList[i].seats);
				}

				//设置请求参数
        console.log(this.$route);
				var resData = {
					token: this.$store.state.userInfo.token,
					cinema_id: this.$store.state.selCineInfo.id,
          plan_key: this.$route.query.plan_key,
          film_code: this.$route.query.film_code,
          city_name: this.$store.state.selCityInfo.region_name,
					seats: reqSeats,
					group_id: this.$store.state.group_id
				};
				//疫情：上传观影人的身份证信息
				// resData.customer_ids = this.getIds();


				return resData;
			},
			confOrder: function() {
				var that = this;
				//没填观影人信息
				// if (this.$store.state.idCards.length == 0) {
				// 	this.$alert('请填写观影人信息', '提示', {
				// 		confirmButtonText: '确定',
				// 	});
				// 	return;
				// }
				
				var resData = that.setOrderRes();
				that.axios.post('/resUrlTB/api/v2/lockOrder', resData)
					.then(function(res) {
						if (res.data.code == 0) {
							var result = res.data.content;
							var countDownResult = that.global.transCountDown(result.expire_time);
							localStorage.m = countDownResult.m;
							localStorage.s = countDownResult.s;
							that.$router.push({
								path: '/payOrder',
								query:{
									order_id: result.order_id,
									lock_seat_apply_key: result.lock_seat_apply_key
								}
							})
						}
					})
			},
			navToIdList: function() {
				this.$router.push({
					path: '/idList',
					query: {
						needSelNum: this.ticInfo.selSeatList.length,
						isSelMode: true
					}
				})
			}
		}
	}
</script>

<style scoped src='@/assets/css/ticConfirm.css'>
</style>
